<template>

    <section class="bannerone-wrapper pt-80px pb-80px" :style="'background-image: url('+dlabData.bannerone.bgImage+')'">
        <div class="container">
            <div class="row align-center">
                <div class="col-md-8">
                    <div class="bannerone-left-content">
                        <h1 class="section-title mb-3 text-white" v-if="dlabData.bannerone.title">{{dlabData.bannerone.title}}</h1>
                        <p class="section-desc text-white mb-4" v-if="dlabData.bannerone.description">{{dlabData.bannerone.description}}</p>
                        <!-- <a v-if="dlabData.bannerone.btntext" :href="dlabData.bannerone.btnUrl ? dlabData.bannerone.btnUrl : '#'" class="btn theme-btn theme-btn-white">
                            {{dlabData.bannerone.btntext}} <el-icon class="icon"><ArrowRight /></el-icon>
                        </a> -->
                        <ask-question btn="Ask Question" btnClass="theme-btn-white"  :showIcon="true" />
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="bannerone-right-lists text-white">
                        <ul class="position-relative">
                            <li class="d-flex align-center fs-15 lh-20 mb-30px">
                                <el-icon><Comment /></el-icon> Anybody can ask a question
                            </li>
                            <li class="d-flex align-center fs-15 lh-20 mb-30px">
                                <el-icon><ChatDotSquare /></el-icon> Anybody can answer
                            </li>
                            <li class="d-flex align-center fs-15 lh-20">
                                <el-icon><DCaret /></el-icon> The best answers are voted up and rise to the top
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>

</template>

<script>
import {Comment, ChatDotSquare, DCaret} from '@element-plus/icons-vue';
import dlabData from '@/store/store.js';
import AskQuestion from '../pieces/AskQuestion.vue';

export default {
    name: 'BannerOne',
    components: {
        Comment,
        ChatDotSquare,
        DCaret,
        AskQuestion,
    },
    data() {
        AskQuestion
        return {
            dlabData
        }
    }
}
</script>


